import { LegalShell } from './legal-shell.tsx'
import { PRIVACY_POLICY } from './privacy-content.ts'

export function PrivacyPage() {
  return <LegalShell translations={PRIVACY_POLICY} current="privacy" />
}
